import { FacturasPorOrigen } from '@/modules/facturacion/FacturasPorOrigen';

export function FacturasDelArt8() {
  return <FacturasPorOrigen origen="TITULOS" vacio="Ninguna factura del Art. 8 coincide" />;
}
